import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import LeftArrowIcon from "../../images/demo/left_arrow_svg";
import RightArrowIcon from "../../images/demo/right_arrow_svg";
import { toFarsiNumber } from "./utils";

export const Pagination = ({ pagination, pageCount }) => {
  let [searchParams, setSearchParams] = useSearchParams();
  const pageNumber = searchParams.get("page")
    ? Number(searchParams.get("page"))
    : 1;
  const pages = [];
  let startPage = pageNumber - 1;
  let endPage = pageNumber + 2;

  if (startPage <= 0) {
    startPage = 1;
  }

  if (endPage > pageCount) {
    endPage = pageCount;
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
    <ol className='pagination'>
      <li className='pagination-item'>
        {pageNumber - 1 < 1 ? (
          <span className='pagination-link'>
            <RightArrowIcon />
          </span>
        ) : (
          <Link
            className='pagination-link'
            to={{ pathname: "", search: `?page=${pageNumber - 1}` }}
            reloadDocument
          >
            <RightArrowIcon />
          </Link>
        )}
      </li>
      {startPage > 1 && (
        <li
          className={`pagination-item pagination-start${
            pageNumber === 1 ? " active" : ""
          }`}
        >
          <Link className='pagination-link' to='' reloadDocument>
            {toFarsiNumber(1)}
          </Link>
        </li>
      )}
      {pages.map((page) => (
        <li
          key={page}
          className={`pagination-item${pageNumber === page ? " active" : ""}`}
        >
          <Link
            className='pagination-link'
            to={{
              pathname: "",
              search: `?page=${page}`,
            }}
            reloadDocument
          >
            <span>{toFarsiNumber(page)}</span>
          </Link>
        </li>
      ))}
      {endPage < pageCount && (
        <li
          className={`pagination-item pagination-end${
            pageNumber === pageCount ? " active" : ""
          }`}
        >
          <Link
            className='pagination-link'
            to={{
              pathname: "",
              search: `?page=${pageCount}`,
            }}
            reloadDocument
          >
            {toFarsiNumber(pageCount)}
          </Link>
        </li>
      )}
      <li className='pagination-item'>
        {pageNumber + 1 > pageCount ? (
          <span className='pagination-link'>
            <LeftArrowIcon />
          </span>
        ) : (
          <Link
            className='pagination-link'
            to={{ pathname: "", search: `?page=${pageNumber + 1}` }}
            reloadDocument
          >
            <LeftArrowIcon />
          </Link>
        )}
      </li>
    </ol>
  );
};
